export const environment = {
	production: false,
	in_maintenance: false,
	API_URL: "https://api-dev.ecotopia.com.ar",
	FRONT_URL: "https://ecotopiadev.web.app",
	cloudStorageBucket: 'ecottopia-files',
	firebase: {
		apiKey: "AIzaSyAk8E0aEFX8wQNEIATb8kLjZ4oRA-mbMqE",
		authDomain: "ecotopia-dev.firebaseapp.com",
		projectId: "ecotopia-dev",
		storageBucket: "ecotopia-dev.appspot.com",
		messagingSenderId: "435826000386",
		appId: "1:435826000386:web:7785ebb520e7d0de85dd1b",
		measurementId: "G-C1F2VK3EJ1"
	},
};
